export default "__VITE_ASSET__4AoSN8RM__"